import { BigNumber } from '../types';

/**
 * @ignore
 */
export function isBigNumber(value: any): boolean {
  return value instanceof BigNumber;
}
